<template>
  <div>
    <Pivot
      v-if="exibir"
      class="altura"
      ref="pivot"
      width="100%"
      v-bind:report="conexao"
      :beforetoolbarcreated="esconder"
      :dataloaded="flexmonsterLoading"
      :licenseKey="licenseKey"
      toolbar
    >
    </Pivot>
    <!-- <div
      v-else
      class="row col-12 justify-center items-center"
      style="height: 70vh"
    >
      <LoadingLogo />
    </div> -->
    <save
      :relatorioSalvo="dadosRelatorioSalvo?.nome"
      :loading="loading"
      :abrir="salvar"
      @emitir="injectOptions"
      @salvarLocal="baixarRelatorioJson"
    />
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";

import Save from "../components/Salvar.vue";
import LinguagemPt from "../pt.json";
// import LoadingLogo from "../../../components/loading/LoadingLogo.vue";

export default defineComponent({
  name: "CompositionAPIDemo",
  components: {
    Save,
    // LoadingLogo,
  },
  emits: ["enviarRespostaEp", "flexmonsterLoading"],
  props: {
    link: {
      type: String,
      required: true,
      default: "",
    },

    url: {
      type: String,
      default: "",
    },

    urlEp: {
      type: String,
      default: "",
    },

    exibir: {
      type: Boolean,
      default: false,
    },

    relatorioCarregado: {
      type: Boolean,
      default: false,
    },

    gerarCsv: {
      type: Boolean,
      default: false,
    },

    dadosRelatorioSalvo: {
      type: Object,
    },

    slice: {
      type: Object,
      default: () => {},
    },

    grid: {
      type: String,
      default: "flat",
    },

    filtros: {
      type: String,
      default: "",
    },
    types: {
      type: Object,
      default: () => {},
    },
    updateLink: {
      type: Number,
    },
    salvarType: {
      type: String,
    },
    showTotals: {
      type: String,
    },
    showGrandTotals: {
      type: String,
      default: "off",
    },
    formats: {
      type: Array,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const route = useRoute();

    let pivot = ref("");
    const salvar = ref(false);
    const loading = ref(false);
    const gridSave = ref("");
    const store = useStore();
    const $q = useQuasar();
    let conexao = ref({
      dataSource: {
        filename: props.link,
        mapping: props.types,
      },

      localization: LinguagemPt,

      options: {
        grid: {
          type: props.grid,
          showGrandTotals: props.showGrandTotals,
          showTotals: props.showTotals,
        },
        datePattern: "dd/MM/yyyy",
        configuratorActive: false,
        defaultDateType: "date string",
        allowBrowsersCache: true,
      },

      slice: props.slice,
      formats: props.formats,
    });

    const esconder = async (toolbar) => {
      pivot.value = toolbar;

      let tabs = toolbar.getTabs();
      toolbar.getTabs = function () {
        tabs = tabs.filter(
          (tab) =>
            tab.id != "fm-tab-connect" &&
            tab.id != "fm-tab-save" &&
            tab.id != "fm-tab-open"
        );

        tabs[6].menu.push({
          id: "fm-tab-expand",
          title: "Expandir Tudo",
          handler: expandir,
        });

        tabs[6].menu.push({
          id: "fm-tab-colaps",
          title: "Fechar Tudo",
          handler: encolher,
        });

        if (
          props.relatorioCarregado == false ||
          props.relatorioCarregado == undefined
        ) {
          tabs.unshift({
            id: "fm-tab-newtab",
            title: "Salvar",
            handler: NomeArquivo,
            icon: this.icons.save,
          });
        }
        return tabs;
      };
    };

    const NomeArquivo = async () => {
      salvar.value = !salvar.value;
    };

    const injectOptions = async (name, tipoAcao) => {
      setTimeout(async () => {
        let grid = await pivot.value.flexmonster.getOptions();
        let columns = await pivot.value.flexmonster.getReport()?.slice?.columns;
        let filtros = await pivot.value.flexmonster.getReportFilters();
        let values = await pivot.value.flexmonster.getReport()?.slice?.measures;
        let rowsFilter = await pivot.value.flexmonster.getReport()?.slice?.rows;

        gridSave.value = {
          layout: grid?.grid?.type,
          showTotals: grid?.grid?.showTotals,
          showGrandTotals: grid?.grid?.showGrandTotals,
          columns: columns,
          rows: rowsFilter,
          filtros: filtros,
          values: values,
        };

        if (tipoAcao == "editar") {
          editar();
          return;
        }
        save(name);
      }, 1000);
    };

    const save = async (nome) => {
      if (nome === "" || nome === undefined) {
        $q.notify({
          message: "Erro a o salvar arquivo, o nome não pode ser vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      loading.value = true;
      try {
        await store.dispatch("rel/salvarRelatorio", {
          nome: nome,
          url: props.url,
          tipoRelatorio: props.salvarType,
          filtros: props.filtros,
          template: JSON.stringify(gridSave.value),
        });
        $q.notify({
          message: "Relatorio salvo com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o salvar relatorio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      loading.value = false;
    };

    const editar = async () => {
      loading.value = true;
      try {
        await store.dispatch("rel/editarRelatorio", {
          id: props.dadosRelatorioSalvo?.id,
          url: props.url,
          filtros: props.filtros,
          template: JSON.stringify(gridSave.value),
        });
        $q.notify({
          message: "Relatorio editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o editar relatorio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      loading.value = false;
    };

    watch(
      () => props.updateLink,
      () => {
        setTimeout(() => {
          pivot.value?.flexmonster?.updateData({
            type: "csv",
            filename: props.link,
          });
          if (
            store.state.rel.relatorioSalvo === null &&
            route.params.id === "carregado" &&
            store.state.rel.relatorioCarregado != null
          ) {
            let dados = store.state.rel.relatorioCarregado;
            gridSave.value = {
              layout: dados.layout,
              showTotals: dados.showTotals,
              showGrandTotals: dados.showGrandTotals,
              columns: dados.columns,
              rows: dados.rows,
              filtros: dados.filtros,
              values: dados.values,
            };
            save(route.name);
            store.commit("rel/ALTERAR_RELATORIO_SALVO", {
              estado: true,
            });
          }
        }, 800);
      }
    );

    watch(
      () => props.link,
      () => {
        conexao.value.dataSource.filename = props.link;
        conexao.value.dataSource.mapping = props.type;
        conexao.value.options.grid.type =
          props.dadosRelatorioSalvo?.layout ||
          props.grid ||
          props.dadosRelatorioSalvo?.template?.layout;
        conexao.value.options.slice = props.slice;
        conexao.value.options.formats = props.formats;
        conexao.value.mapping = props.types;
        conexao.value.options.grid.showTotals = props.showTotals;
        conexao.value.options.grid.showGrandTotals = props.showGrandTotals;
      }
    );

    const gerarLinkCsv = async () => {
      const api = await store.dispatch("autenticacao/criarApiFlexmonster");
      const response = await api.get(props.dadosRelatorioSalvo?.url);
      emit("enviarRespostaEp", response.data);
    };

    const baixarRelatorioJson = async () => {
      loading.value = true;
      let configuracoesRelatorio = {};

      let grid = await pivot.value.flexmonster.getOptions();
      let columns = await pivot.value.flexmonster.getReport()?.slice?.columns;
      let filtros = await pivot.value.flexmonster.getReportFilters();
      let values = await pivot.value.flexmonster.getReport()?.slice?.measures;
      let rows = await pivot.value.flexmonster.getReport()?.slice?.rows;

      configuracoesRelatorio = {
        rotaNome: route.name,
        url: props.url,
        filtrosTela: props.filtros,
        layout: grid?.grid?.type,
        showTotals: grid?.grid?.showTotals,
        showGrandTotals: grid?.grid?.showGrandTotals,
        columns: columns,
        rows: rows,
        filtros: filtros,
        values: values,
      };
      let json = JSON.stringify(configuracoesRelatorio, null, 2);

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/json;charset=utf-8," + encodeURIComponent(json)
      );
      element.setAttribute("download", `relatorio-${route.name}`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
      loading.value = false;
    };

    watch(
      () => props.gerarCsv,
      () => {
        if (!props.gerarCsv) {
          return;
        }
        gerarLinkCsv();
      }
    );

    const expandir = async () => {
      await pivot.value.pivot.expandAllData();
    };

    const encolher = async () => {
      await pivot.value.pivot.collapseAllData();
    };

    const flexmonsterLoading = async () => {
      emit("flexmonsterLoading", false);
    };

    return {
      pivot,
      esconder,
      conexao,
      save,
      salvar,
      NomeArquivo,
      injectOptions,
      loading,
      licenseKey: process.env.VUE_APP_FLEXMONSTER_TOKEN,
      expandir,
      encolher,
      flexmonsterLoading,
      editar,
      baixarRelatorioJson,
    };
  },
});
</script>

<style scoped>
.altura {
  height: 80vh !important;
}
</style>
